module.exports = __webpack_public_path__ + "static/img/1_6_1.662ddb1f.jpg";